/* eslint-disable */
// @ts-nocheck
/*
* This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
*/

export enum FeatureSetType {
  RAW = "RAW",
  ENGINEERED = "ENGINEERED",
}

export enum FeatureType {
  AUTOMATIC_DISCOVERY = "AUTOMATIC_DISCOVERY",
  COMPOSITE = "COMPOSITE",
  NUMERICAL = "NUMERICAL",
  CATEGORICAL = "CATEGORICAL",
  TEMPORAL = "TEMPORAL",
  TEXT = "TEXT",
}

export enum FeatureSetFlow {
  OFFLINE_ONLINE_AUTOMATIC = "OFFLINE_ONLINE_AUTOMATIC",
  OFFLINE_ONLINE_MANUAL = "OFFLINE_ONLINE_MANUAL",
  OFFLINE_ONLY = "OFFLINE_ONLY",
  ONLINE_ONLY = "ONLINE_ONLY",
}